interface IProps {
  size: number;
}

export const AttachmentIcon = ({ size }: IProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 0C7.84095 0 9.33333 1.49238 9.33333 3.33333V11.3333C9.33333 13.9107 7.244 16 4.66667 16C2.08934 16 0 13.9107 0 11.3333V6H1.33333V11.3333C1.33333 13.1743 2.82572 14.6667 4.66667 14.6667C6.50762 14.6667 8 13.1743 8 11.3333V3.33333C8 2.22876 7.10457 1.33333 6 1.33333C4.89543 1.33333 4 2.22876 4 3.33333V11.3333C4 11.7015 4.29848 12 4.66667 12C5.03486 12 5.33333 11.7015 5.33333 11.3333V4H6.66667V11.3333C6.66667 12.4379 5.77124 13.3333 4.66667 13.3333C3.5621 13.3333 2.66667 12.4379 2.66667 11.3333V3.33333C2.66667 1.49238 4.15905 0 6 0Z"
      fill="currentColor"
    />
  </svg>
);
